import loader from './lib/Loader';

loader('header', '.header');
loader('plyr', '.plyr');
loader('timeline', '.timeline__steps');
loader('tabs', '.tabs');
loader('sector-slider', '.sector-slider');
loader('countdown', '.countdown');
loader('clipboard', '.clipboard');
loader('filter-scrolldown', '.insight-archive__filter');
loader('video-popup', '.title-text-video__popup');
loader('mobile-menu', '.mobile-menu > div > .menu > .menu__item--has-children');
loader('footer', '.footer__menus');
